import React from "react";
import InfoAlert from "./InfoAlert";
import SuccessAlert from "./SuccessAlert";
import { connect } from "react-redux";
import {
  clearErrors,
  clearInfoMessage,
  clearWarningMessage,
  clearSuccessMessage,
} from "../../store/alerts/alertsActions";
import ModalAlert from "./ModalAlert";

interface IProps {
  alerts: {
    info: string[] | null;
    success: string | null;
    warnings: string[] | null;
    errors: string[] | null;
  };
  clearErrors: Function;
  clearWarningMessage: Function;
  clearSuccessMessage: Function;
  clearInfoMessage: Function;
}

export const AlertsHandler: React.FC<IProps> = ({
  alerts,
  clearErrors,
  clearSuccessMessage,
  clearInfoMessage,
  clearWarningMessage,
}: IProps) => {
  return (
    <React.Fragment>
      <ModalAlert onHide={clearErrors} errors={alerts.errors} />
      <ModalAlert
        onHide={clearWarningMessage}
        errors={alerts.warnings}
        isWarning
      />
      <InfoAlert info={alerts.info} clearInfoMessage={clearInfoMessage} />
      <SuccessAlert
        successMessage={alerts.success}
        clearSuccessMessage={clearSuccessMessage}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps, {
  clearErrors,
  clearWarningMessage,
  clearSuccessMessage,
  clearInfoMessage,
})(AlertsHandler);
